export default __webpack_public_path__ + "30cc17eb7880c03fee6fcaa4bdabded7.png";